import { SubscriptionPlan } from '@repo/graphql-types'
import type { SubscriptionType } from '@repo/graphql-types'
import type { StudioAiPricingPlan } from './studio-ai-plans'

export const TEAM_MONTHLY_SUBSCRIPTION_TYPE: SubscriptionPlan.TeamMonthly =
  SubscriptionPlan.TeamMonthly

export const STUDIO_UNLIMITED_YEARLY_SUBSCRIPTION_TYPE: SubscriptionPlan.StudioUnlimitedYearly =
  SubscriptionPlan.StudioUnlimitedYearly

export type TeamSubscriptionType = SubscriptionPlan.TeamMonthly
export type StudioUnlimitedSubscriptionType = SubscriptionPlan.StudioUnlimitedYearly
export type PaymentSubscriptionType =
  | SubscriptionType
  | TeamSubscriptionType
  | StudioUnlimitedSubscriptionType
  | StudioAiPricingPlan

export function isTeamSubscriptionType(
  subscriptionType: PaymentSubscriptionType | string | null | undefined,
): subscriptionType is TeamSubscriptionType {
  return subscriptionType === TEAM_MONTHLY_SUBSCRIPTION_TYPE
}

export function isStudioUnlimitedSubscriptionType(
  subscriptionType: PaymentSubscriptionType | string | null | undefined,
): subscriptionType is StudioUnlimitedSubscriptionType {
  return subscriptionType === STUDIO_UNLIMITED_YEARLY_SUBSCRIPTION_TYPE
}
